export default [
  {
    title: "컨베이어 검사 시 주의사항",
    tableHeaderTitle: "검사 시 주의 사항",
    list: [
      {
        content: "가. 주변의 작업자에게 검사중임을 알리는 경고 표지를 준비하여 현장에 부착\n예) “출입금지”, “작동(운전, 조작) 금지”, “검사 중” 등",
        isChecked: "",
      },
      {
        content: "나. 운전을 정지하거나, 비상정지를 시험하는 경우 사업장 조업 상태를 확인하여 조업에 방해가 최소화 되도록 한다.",
        isChecked: "",
      },
      {
        content: "다. 컨베이어의 벨트와 풀리 사이 등 가동부분과 비가동부분에 옷자락 등이 말리거나, 이송 화물에 부딪히는 등 위험이 발생되지 않도록 유의하여 검사한다.",
        isChecked: "",
      },
      {
        content: "라. 특별한 경우가 아니면 방책 내부로 접근하거나 신체의 일부를 넣지 않아야 한다. 다만, 불가피하게 방책 내부에 접근이 필요한 경우, 연동장치, 내부 기계의 정지상태 등을 확인하고 감시인을 배치하는 등 검사원의 안전을 확보한 후 접근하여야 한다.",
        isChecked: "",
      },
      {
        content: "마. 안전장치는 고장일 수 있으므로 이를 항상 유념하여야 한다.",
        isChecked: "",
      },
      {
        content: "바. 작업대 검사시 미끄럼짐 및 추락, 전도 등에 주의 할 것",
        isChecked: "",
      },
    ],
  },
  {
    title: "조작반 외부 확인사항",
    tableHeaderTitle: "확인사항",
    list: [
      {
        title: "1. 검사대상품 확인",
        content: "일반내용 확인(컨베이어 종류, 단위구간 종류, 제어반 대수, 이송화물 종류, 시간당 운송능력 등)",
        isChecked: "",
      },
      {
        title: "1. 검사대상품 확인",
        content: "명판표시내용 확인(제조자, 제조연월일 등)",
        isChecked: "",
      },
      {
        title: "1. 검사대상품 확인",
        content: "명판이 이송장치에 부착되어 있는 경우, 이송장치 검사 시 확인",
        isChecked: "",
      },
      {
        title: "2. 조작장치 및 표시등",
        content: "기동/정지 스위치 표시 및 조작상태 확인",
        isChecked: "",
      },
      {
        title: "2. 조작장치 및 표시등",
        content: "조작버튼 색상 적절여부 확인",
        isChecked: "",
      },
      {
        title: "2. 조작장치 및 표시등",
        content: "누름버튼 식별표시 적절 여부 확인",
        isChecked: "",
      },
      {
        title: "2. 조작장치 및 표시등",
        content: "표시등 색상 적절여부 확인",
        isChecked: "",
      },
      {
        title: "3. 전원차단장치 및 운전모드 적절여부 확인",
        content: "전원차단장치 적절성 여부 확인",
        isChecked: "",
      },
      {
        title: "3. 전원차단장치 및 운전모드 적절여부 확인",
        content: "운전모드 구분표시, 키스위치 확인(전환 시 위험한 상황이 초래될 경우)",
        isChecked: "",
      },
      {
        title: "3. 전원차단장치 및 운전모드 적절여부 확인",
        content: "안전장치가 모든 운전모드에서 유효한지 확인",
        isChecked: "",
      },
      {
        title: "3. 전원차단장치 및 운전모드 적절여부 확인",
        content: "모드 선택 스위치와 운전스위치의 기능 분리 여부",
        isChecked: "",
      },
      {
        title: "4. 비상정지장치 확인",
        content: "수동복귀 후 자동기동으로 사고의 우려가 발생하는지 여부 확인",
        isChecked: "",
      },
      {
        title: "5. 경보장치",
        content: "시야에서 벗어나는 작업구역 및 통행구역 유무 확인\n» 해당 구역이 있는 경우 적절한 장소에 경보장치의 유무 확인",
        isChecked: "",
      },
      {
        title: "6. 외함 및 경고표시 확인",
        content: "외함 또는 방호망 설치상태 확인",
        isChecked: "",
      },
      {
        title: "6. 외함 및 경고표시 확인",
        content: "키 등 잠금장치 유무 확인",
        isChecked: "",
      },
      {
        title: "6. 외함 및 경고표시 확인",
        content: "전기장치 경고표시 부착 여부 확인",
        isChecked: "",
      },
    ],
  },
  {
    title: "조작반 내부 확인사항",
    tableHeaderTitle: "확인사항",
    list: [
      {
        title: "1. 감전사고 방지",
        content: "외함 개방시 충전부 차단 또는 충전부의 접촉방호 조치 여부 확인",
        isChecked: "",
      },
      {
        title: "2. 과전류 보호",
        content: "과전류 보호장치(차단기 또는 퓨즈) 설치여부 및 차단용량 확인",
        isChecked: "",
      },
      {
        title: "2. 과전류 보호",
        content: "분기회로마다 설치여부 확인",
        isChecked: "",
      },
      {
        title: "3. 과부하 보호(정격출력 0.5kW 이상일 경우)",
        content: "과부하 감지장치 설치여부 확인",
        isChecked: "",
      },
      {
        title: "3. 과부하 보호(정격출력 0.5kW 이상일 경우)",
        content: "중성선 제외한 모든 상도체에 감지장치 설치여부 확인",
        isChecked: "",
      },
      {
        title: "3. 과부하 보호(정격출력 0.5kW 이상일 경우)",
        content: "EOCR 셋팅값 및 정상작동 확인\n» 과전류설정, 기동지연시간, 동작시간 설정값의 과한 셋팅여부 확인\n» TEST 버튼을 눌러 정상작동 여부 확인",
        isChecked: "",
      },
      {
        title: "4. 제어회로 및 제어기능 확인",
        content: "제어회로 전원을 위한 1,2차측이 분리된 권선방식의 제어용 변압기 설치여부 확인\n» 1대의 전동기와 최대 2대의 제어장치(연동장치, 기동/정지 제어위치)를 갖춘 기계 또는 자율안전확인 신고제도 시행 이전 생산설치된 제품에 대해서는 변압기 생략 가능",
        isChecked: "",
      },
      {
        title: "5. 접지 확인 및 접지값 측정",
        content: "접지의 적절성 확인 및 접지저항 측정\n» 400V 미만일 때 100Ω 이하일 것, 400V 이상일 때 10Ω이하일 것",
        isChecked: "",
      },
      {
        title: "6. 절연저항 측정",
        content: "전원선과 보호본딩회로 사이 500V 인가하여 측정된 절연저항이 1MΩ 이상일 것",
        isChecked: "",
      },
      {
        title: "7. 전선색상 및 배선 상태",
        content: "전선색상 및 배선 굵기 적절 여부 확인",
        isChecked: "",
      },
      {
        title: "7. 전선색상 및 배선 상태",
        content: "배선 손상, 파손, 인입구 피복 보호조치, 단자체결 상태 등 확인\n» 이송장치에서도 해당사항 검사 실시",
        isChecked: "",
      },
      {
        title: "8. 이상온도 보호(저항가열회로, 히터 등을 사용하는 회로)",
        content: "온도감지장치 및 냉각장치 설치여부 확인",
        isChecked: "",
      },
    ],
  },
  {
    title: "이송장치",
    tableHeaderTitle: "확인사항",
    list: [
      {
        title: "1. 외부",
        content: "날카로운 모서리, 돌출부 유무 확인",
        isChecked: "",
      },
      {
        title: "1. 외부",
        content: "프레임 등 구조물 및 풀리, 롤러 등 주요부품 균열 또는 손상 확인",
        isChecked: "",
      },
      {
        title: "1. 외부",
        content: "가동부분, 정지지부분 등 위험한 틈 유무 확인",
        isChecked: "",
      },
      {
        title: "2. 이탈·낙하방지조치",
        content: "화물 이탈방지조치 확인(가이드 난간 등)",
        isChecked: "",
      },
      {
        title: "2. 이탈·낙하방지조치",
        content: "싣고 내리는 곳 낙하 방지조치 확인(끝단 기계식 스토퍼 등)",
        isChecked: "",
      },
      {
        title: "2. 이탈·낙하방지조치",
        content: "작업·통행구역 위를 지나는 곳의 화물낙하 방지조치 확인(언더가드 플레이트, 철망 등)",
        isChecked: "",
      },
      {
        title: "2. 이탈·낙하방지조치",
        content: "경사 또는 수직 컨베이어의 운반구 이탈, 역주행 방지조치 확인(래칫, 캠클러치 등)",
        isChecked: "",
      },
      {
        title: "3. 덮개, 울, 물림보호물, 감응형 방호장치 등 설치",
        content: "동력전달 부분",
        isChecked: "",
      },
      {
        title: "3. 덮개, 울, 물림보호물, 감응형 방호장치 등 설치",
        content: "벨트, 풀리, 롤러, 체인, 스프라켓, 스크류",
        isChecked: "",
      },
      {
        title: "3. 덮개, 울, 물림보호물, 감응형 방호장치 등 설치",
        content: "호퍼, 슈트의 개구부 및 장력 유지장치",
        isChecked: "",
      },
      {
        title: "3. 덮개, 울, 물림보호물, 감응형 방호장치 등 설치",
        content: "기타 위험한 틈(가동부분, 정지부분 등)",
        isChecked: "",
      },
      {
        title: "3. 덮개, 울, 물림보호물, 감응형 방호장치 등 설치",
        content: "화상의 우려가 있는 구간\n※ 제외구간 : 안전거리 확보되는 경우(KS B ISO 13857), 벨트가 물림지점에서 50mm 이상 이격되는 경우, 풀코드 스위치를 설치한 경우",
        isChecked: "",
      },
      {
        title: "4. 근로자 작업구역 비상정지장치",
        content: "작업구역 비상정지장치, 풀코드 스위치, 풀코드 스위치 현장 설치",
        isChecked: "",
      },
      {
        title: "5. 벨트 컨베이어 안전장치",
        content: "경사부 역주행 방지장치\n» 화물 전체 적재량 500kg 이하, 1개 단위 화물 중량 30kg 이하는 예외",
        isChecked: "",
      },

      {
        title: "5. 벨트 컨베이어 안전장치",
        content: "벨트, 풀리에 점착되기 쉬운 화물의 경우 벨트클리너, 풀리 스크래퍼 설치",
        isChecked: "",
      },

      {
        title: "5. 벨트 컨베이어 안전장치",
        content: "대형 호퍼 및 슈트에 점검구 설치",
        isChecked: "",
      },
      {
        title: "5. 벨트 컨베이어 안전장치",
        content: "중력식 장력유지장치에 울 및 추 낙하방지장치 설치",
        isChecked: "",
      },
      {
        title: "6. 트롤리 컨베이어 안전장치",
        content: "견인식 트롤리의 경우 주라인 및 분기라인 구동장치에 과부하방지장치 설치\n» 복수구동 컨베이어의 경우 과부하방지장치 작동 시 다른 구동장치 전부 정지",
        isChecked: "",
      },
      {
        title: "6. 트롤리 컨베이어 안전장치",
        content: "체인, 행거, 트롤리 접속상태",
        isChecked: "",
      },
      {
        title: "6. 트롤리 컨베이어 안전장치",
        content: "경사부 역주행 방지장치 설치",
        isChecked: "",
      },
      {
        title: "6. 트롤리 컨베이어 안전장치",
        content: "복수 레일식의 경우 푸셔도그와 트롤리가 경사부에서 원활이 이동",
        isChecked: "",
      },
      {
        title: "6. 트롤리 컨베이어 안전장치",
        content: "분기장치, 합류장치 등의 레일 단락부에 낙하방지장치(스토퍼 등) 설치",
        isChecked: "",
      },
      {
        title: "7. 롤러 컨베이어 안전장치",
        content: "분기 또는 상승 직전에 화물이송의 정지여부 확인",
        isChecked: "",
      },
      {
        title: "8. 스크류 컨베이어 안전장치",
        content: "화물 공급구 및 배출구는 스크류가 접촉될 위험이 없는 구조 여부 또는 방호울 확인",
        isChecked: "",
      },
      {
        title: "9. 버킷 컨베이어 안전장치",
        content: "버킷 이동용 케이싱 확인(청소 용이, 불시 개방 불가 구조)",
        isChecked: "",
      },
      {
        title: "9. 버킷 컨베이어 안전장치",
        content: "유해한 화물을 운반하는 경우 밀폐구조 케이싱 설치",
        isChecked: "",
      },
      {
        title: "9. 버킷 컨베이어 안전장치",
        content: "역주행 방지장치 설치 및 정상작동 확인\n» 화물 전체 적재량 300kg이하, 스프로킷/풀리의 수직 축간거리가 5m 이하인 경우 제외",
        isChecked: "",
      },
      {
        title: "10. 기타 기능별 안전장치",
        content: "기복, 신축, 선회, 승강 : 고정장치 설치여부 확인(기복의 경우 불시낙하 방지장치나 크랭크 반동 방지장치 확인)",
        isChecked: "",
      },
      {
        title: "10. 기타 기능별 안전장치",
        content: "이동식 : 이동용 바퀴 고정 잠금장치 설치여부 확인",
        isChecked: "",
      },
      {
        title: "10. 기타 기능별 안전장치",
        content: "조작반에서 시야 외 작업·통행구역 : 경보장치 유무 확인",
        isChecked: "",
      },
    ],
  },
  {
    title: "통로 및 바닥",
    tableHeaderTitle: "확인사항",
    list: [
      {
        title: "1. 통로 폭 확인",
        content: "60cm 이상(통로에 인접하여 고정된 구조물 등이 있는 경우는 40cm)",
        isChecked: "",
      },
      {
        title: "1. 통로 폭 확인",
        content: "추락 우려가 있는 경우 안전난간 설치여부 확인",
        isChecked: "",
      },
      {
        title: "2. 바닥 상태",
        content: "미끄럼, 걸림 등 넘어짐 위험 여부 확인",
        isChecked: "",
      },
      {
        title: "2. 바닥 상태",
        content: "개구부가 있는 경우 안전난간, 울, 충분한 강도의 덮개 등 설치 확인",
        isChecked: "",
      },
      {
        title: "3. 통로 장애물 및 구동부 인접부위",
        content: "통로면 높이 2m 이내 장애물 유무 확인(불가피한 경우 경고 표지 등 조치)",
        isChecked: "",
      },
      {
        title: "3. 통로 장애물 및 구동부 인접부위",
        content: "구동부 인접부위에 덮개, 울 등 설치 확인",
        isChecked: "",
      },
      {
        title: "4. 가설통로, 사다리식 통로 확인",
        content: "산업안전보건기준에 관한 규칙에 적합여부 확인",
        isChecked: "",
        rowType: "customContent",
      },
      {
        title: "5. 건널장치 확인",
        content: "인필플레이트, 건널다리, 감응형방호장치, 연동가드, 정지/시작장치",
        isChecked: "",
      },
      {
        title: "6. 컨베이어 밑 통행구역",
        content: "가동부 높이 2.5m 미만인 구역은 울 또는 덮개 설치 확인",
        isChecked: "",
      },
      {
        title: "6. 컨베이어 밑 통행구역",
        content: "통과 높이가 0.7~2.5m로 변하는 컨베이어 밑은 체인커튼, 메달린 봉 등 설치 확인",
        isChecked: "",
      },
      {
        title: "7. 롤러 컨베이어 안전장치",
        content: "분기 또는 상승 직전에 화물이송의 정지여부 확인",
        isChecked: "",
      },
      {
        title: "8. 스크류 컨베이어 안전장치",
        content: "화물 공급구 및 배출구는 스크류가 접촉될 위험이 없는 구조 여부 또는 방호울 확인",
        isChecked: "",
      },
      {
        title: "9. 버킷 컨베이어 안전장치",
        content: "버킷 이동용 케이싱 확인(청소 용이, 불시 개방 불가 구조)",
        isChecked: "",
      },
      {
        title: "9. 버킷 컨베이어 안전장치",
        content: "유해한 화물을 운반하는 경우 밀폐구조 케이싱 설치",
        isChecked: "",
      },
      {
        title: "9. 버킷 컨베이어 안전장치",
        content: "역주행 방지장치 설치 및 정상작동 확인\n» 화물 전체 적재량 300kg이하, 스프로킷/풀리의 수직 축간거리가 5m 이하인 경우 제외",
        isChecked: "",
      },
      {
        title: "10. 기타 기능별 안전장치",
        content: "기복, 신축, 선회, 승강 : 고정장치 설치여부 확인(기복의 경우 불시낙하 방지장치나 크랭크 반동 방지장치 확인)",
        isChecked: "",
      },
      {
        title: "10. 기타 기능별 안전장치",
        content: "이동식 : 이동용 바퀴 고정 잠금장치 설치여부 확인",
        isChecked: "",
      },
      {
        title: "10. 기타 기능별 안전장치",
        content: "조작반에서 시야 외 작업·통행구역 : 경보장치 유무 확인",
        isChecked: "",
      },
    ],
  },
];
